import { observable } from 'mobx';
import {BasePreviewViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import { FacilityOrderTemplateService } from 'application/facility-order/services';

@applicationContext
class FacilityOrderTemplatePreviewViewStore extends BasePreviewViewStore {
	@observable accessor facilityOrderTemplateItems = [];

    constructor(rootStore, componentProps) {
        const id = componentProps.modalParams.data.id;
        const service = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const modalParams = componentProps.modalParams;
        super(rootStore, {
            name: 'event',
            id: id,
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await service.get(id, {embed:'FacilityOrderTemplateItems'});     
                        this.facilityOrderTemplateItems = response.data.facilityOrderTemplateItems;
                        return response.data;
                    }
                }
            },
        });

        this.modalParams = modalParams;
        this.titleData = this.modalParams.data;
        this.service = service;
        this.templateItems = this.templateItems;
    }
}

export default FacilityOrderTemplatePreviewViewStore;
